import { useCallback, useEffect } from "react";
import { useFormikContext } from "formik";
import useProperties from "./use-properties";

import useAuth from "./use-auth.js";

export default function useDependentField(
  fieldName,
  dependOnFieldName,
  valueExtractor,
) {
  const { values, setFieldValue } = useFormikContext();
  const dependOnFieldValue = values[dependOnFieldName];

  useEffect(() => {
    if (dependOnFieldName && dependOnFieldValue) {
      valueExtractor(dependOnFieldValue).then((value) => {
        if (value !== undefined && value != null) {
          setFieldValue(fieldName, value);
        }
      });
    }
  }, [
    dependOnFieldName,
    dependOnFieldValue,
    fieldName,
    setFieldValue,
    valueExtractor,
  ]);
}

export function usePropertyExtractor(fieldName) {
  const { auth } = useAuth();
  const { propertiesById } = useProperties({
    noFetch: !auth.accessToken,
    withById: true,
  });

  return useCallback(
    (dependOnFieldValue) => {
      const property = propertiesById[parseInt(dependOnFieldValue)];
      if (property === undefined) {
        return Promise.resolve(undefined);
      }

      return Promise.resolve(property[fieldName]);
    },
    [fieldName, propertiesById],
  );
}
